import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EActionType, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { IReadQueueRequest } from '../../types/IApiTypes';
import { handleApiErrorWithFallback } from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';

export const QueueApi = {
  //get all queue items from the api
  getQueueData: (payload: IReadQueueRequest, dispatch: Dispatch) => {
    let queryParams = new URLSearchParams();
    if (payload.caller !== EActionType.Refresh) {
      queryParams = new URLSearchParams({
        [EUrlParams.Page]: String(payload.page),
        [EUrlParams.Limit]: String(payload.limit),
      });
      if (payload.searchCode) {
        queryParams.set(EUrlParams.Search, payload.searchCode);
      }
    }

    // Only send request body for refresh operations
    const requestBody =
      payload.caller === EActionType.Refresh && payload.searchCode
        ? { filters: { code: payload.searchCode } }
        : {};

    return AxiosClient.post(`queue/v1/read?${queryParams.toString()}`, requestBody)
      .then((response) => {
        return handlePaginatedData(response, payload);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: payload.page, searchKey: payload.searchCode, caller: payload.caller },
          EAction.Read,
          EApiType.QueueKey
        );
      });
  },
};
